import { Link } from "gatsby"
import React from "react"
import ReactDOMServer from "react-dom/server"

import JsonLd from "@atoms/JsonLd/JsonLd"

import styles from "./Breadcrumb.module.scss"

const Breadcrumb = ({ type, ancestors, current }) => {
  const SITE_URL = process.env.GATSBY_SITEURL || `https://www.almainsights.fi`

  const camelCase = require("camelcase")

  const currentString = ReactDOMServer.renderToString(current).replace(
    /(<([^>]+)>)/gi,
    ""
  )

  const itemListElement = ancestors
    ? [
        ...ancestors.map((ancestor, i) => {
          const slash = ancestor?.url?.substr(-1) === "/" ? "" : "/"

          return {
            "@type": "ListItem",
            name: ancestor.title,
            item: `${SITE_URL}${ancestor.url}${slash}`,
          }
        }),
        ...[
          {
            "@type": "ListItem",
            name: currentString,
          },
        ],
      ]
    : []

  const json = {
    id: currentString,
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: itemListElement.map((item, i) => {
      return { ...item, position: i + 1 }
    }),
  }

  const ancestorList = ancestors
    ? ancestors.map((ancestor, i) => {
        const slash = ancestor?.url?.substr(-1) === "/" ? "" : "/"

        return (
          <div className={`${styles.item} ${styles.ancestor}`} key={i}>
            <Link to={`${ancestor.url}${slash}`} className={styles.link}>
              {ancestor.title}
            </Link>
            <span className={styles.separator}>&rsaquo;</span>
          </div>
        )
      })
    : false

  return (
    <div className={`${styles.list} ${styles[camelCase("" + type)]}`}>
      <div className={styles.ancestors}>{ancestorList}</div>
      <div className={`${styles.item} ${styles.currentItem}`}>
        <span className={styles.current}>{current}</span>
      </div>
      <JsonLd json={json} />
    </div>
  )
}

Breadcrumb.defaultProps = {}

export default Breadcrumb

Breadcrumb.defaultProps = {
  type: "regular",
}
